var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0821 6.98486H1.91793C1.29452 6.98486 0.788574 7.49081 0.788574 8.11422V14.8903C0.788574 15.5137 1.29452 16.0197 1.91793 16.0197H12.0821C12.7055 16.0197 13.2115 15.5137 13.2115 14.8903V8.11422C13.2115 7.49081 12.7055 6.98486 12.0821 6.98486Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9528 6.98466V5.29063C10.9528 3.10759 9.18314 1.33789 7.0001 1.33789C4.81706 1.33789 3.04736 3.10759 3.04736 5.29063V6.98466",
    stroke: "#00A3FA",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.664e6895ab825aac4d4e68f947abcd8e.svg";
export { ForwardRef as ReactComponent };